import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './firebaseConfig';
import { useRole } from '../auth/RoleContext';
import { canAccess, firstAllowedPath } from '../auth/permissions';

const ProtectedRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth);
  const { role, loadingRole } = useRole();
  const location = useLocation();

  if (loading || loadingRole) return <div>Loading...</div>;
  if (!user) return <Navigate to="/login" />;

  // Role-based screen gating: redirect to the first screen the role can use.
  if (role && !canAccess(role, location.pathname)) {
    return <Navigate to={firstAllowedPath(role)} replace />;
  }

  return children;
};

export default ProtectedRoute;
